import { createSelector } from '@reduxjs/toolkit';

const selectChatState = (state) => state.chat;

export const selectChatConversations = createSelector([selectChatState], (s) => s.conversations);

export const selectChatSidebarMeta = createSelector([selectChatState], (s) => s.sidebarMeta);

export const selectActiveConversationId = createSelector(
    [selectChatState],
    (s) => s.activeConversationId,
);

export const selectMessagesByConversation = createSelector(
    [selectChatState],
    (s) => s.messagesByConversation,
);

export const selectActiveConversation = createSelector(
    [selectChatConversations, selectActiveConversationId],
    (conversations, id) => (id ? conversations.find((c) => c.id === id) ?? null : null),
);

export const selectMessagesForActiveConversation = createSelector(
    [selectMessagesByConversation, selectActiveConversationId],
    (byConv, id) => (id ? byConv[id] ?? [] : []),
);

export const selectChatLoading = createSelector([selectChatState], (s) => ({
    conversations: s.isLoadingConversations,
    messages: s.isLoadingMessages,
}));

export const selectChatError = createSelector([selectChatState], (s) => s.error);

export const selectTotalChatUnread = createSelector([selectChatConversations], (conversations) =>
    conversations.reduce((sum, c) => sum + (c.unreadCount || 0), 0),
);
